import {DataLayerModel} from "@merchant-webapp/components";

export class GeolocationChangeDataLayer extends DataLayerModel {
	public static readonly EVENT_NAME: string = "GEOLOCATION_CHANGED";
	public constructor() {
		super(GeolocationChangeDataLayer.EVENT_NAME);
	}
}